import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=8c6709dc&scoped=true&"
import script from "./PermissionDenied.vue?vue&type=script&lang=js&"
export * from "./PermissionDenied.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=8c6709dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6709dc",
  null
  
)

export default component.exports